export default "__VITE_ASSET__BZ11Rwqe__"